import i18n from '@/utils/i18n';

export function convertMethod(value) {
  const method = value?.split('.');
  return i18n.t(`shared.${method?.[1]?.toLowerCase()}`);
}
